// Module
var code = "<react-component name=\"EditPerformedWorkout\"></react-component>\n";
// Exports
module.exports = code;